import { select } from '@js/util/select.js'
import $ from 'jquery'

select('.wpdt-accordion', element => {
  $(element).Accordion({
    toggleContainer: '.accordion-inner',
    toggleButton: '.accordion-heading',
    toggleClass: 'accordion-open',
  })
})
